<template>
    <div class="panel panel-default" style="margin-bottom: 0px">
        <div class="container-fluid">

            <div v-if="alertMessage !== ''" class="row">
                <div :class="getClass()" role="alert">
                    {{ alertMessage }}
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="form-group">
                        <div class="row">

                            <div class="col-lg-5 col-md-5">
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox"
                                            v-model="exclusiveRates"
                                            @change="checkRates"
                                            id="rates"
                                        >
                                        Recibe sólo Tarifas exclusivas
                                    </label>
                                </div>
                            </div>

                            <div class="col-lg-5 col-md-5">
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox"
                                            v-model="exclusiveDiscounts"
                                            @change="checkDiscounts"
                                            id="discounts"
                                        >
                                        Recibe sólo Descuentos exclusivos
                                    </label>
                                </div>
                            </div>

                            <div class="col-lg-2 col-md-2">
                                <button
                                        class="btn btn-primary pull-right"
                                        type="submit"
                                        :disabled="!enabledSave"
                                        @click="saveList"
                                        style="margin-top:10px;"
                                >
                                    Guardar
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import {mapMutations, mapState} from "vuex";

    export default {
        name: 'agency-data',
        computed: {
            ...mapState('DirectProduct',['storeAgency']),
            /*
            // asi genera un warning en consola
            // Computed property xxx was assigned to but it has no setter
            exclusiveRates() {
                return (this.data.exclusiveRates == 1) ? true : false;
            },
            exclusiveDiscounts() {
                return this.data.exclusiveDiscounts == 1 ? true : false;
            },
            */
            exclusiveRates: {
                get() {
                    return this.data.exclusiveRates == 1 ? true : false;
                },
                set(value) {
                    return this.data.exclusiveRates == 1 ? true : false;
                }
            },
            exclusiveDiscounts: {
                get() {
                    return this.data.exclusiveDiscounts == 1 ? true : false;
                },
                set(value) {
                    return this.data.exclusiveDiscounts == 1 ? true : false;
                }
            }
        },
        data(){
            return {
                data: {},
                initialData: {},
                errorCode: 0,
                context: 'DirectProductConfig/DirectProductController/',
                enabledSave: false,
                alertMessage: ''
            }
        },
        methods: {
            ...mapMutations('DirectProduct',['fillAgencyData','fillHasModified']),
            saveList() {
                return new Promise((resolve,reject) => {
                    this.$http.get(this.context + 'saveAgencyData', {
                        params: {
                            agencyId: this.storeAgency.id,
                            exclusiveRates: this.data.exclusiveRates,
                            exclusiveDiscounts: this.data.exclusiveDiscounts,
                            oldRates: this.initialData.exclusiveRates,
                            oldDiscounts: this.initialData.exclusiveDiscounts
                        }
                    }).then(({data}) => {

                        if (data.result) {
                            this.reinitializeData();
                            this.alertMessage = data.data[0];
                            let self = this;
                            setTimeout(function () {
                                self.alertMessage = '';
                            }, 5000);
                        } else {
                            this.alertMessage = data.data.error_message;
                        }

                        this.enabledSave = false;

                        resolve(true);
                    }).catch( error => {
                        reject(error);
                    });
                });
            },
            checkRates(e) {
                this.data.exclusiveRates = this.data.exclusiveRates == 0 ? 1 : 0;
                this.checkChanged();
            },
            checkDiscounts(e) {
                this.data.exclusiveDiscounts = this.data.exclusiveDiscounts == 0 ? 1 :0;
                this.checkChanged();
            },
            checkChanged () {
                if (this.initialData.exclusiveRates != this.data.exclusiveRates ||
                    this.initialData.exclusiveDiscounts != this.data.exclusiveDiscounts) {
                    this.enabledSave = true;
                } else {
                    this.enabledSave = false;
                }

                this.fillHasModified({ "data": "agency", "value": this.enabledSave})
            },
            getClass() {
                if (this.alertMessage.length>90) {
                    return 'alert alert-success';
                } else {
                    return 'alert alert-danger';
                }
            },
            reinitializeData() {
                this.fillAgencyData(this.data);
                this.initialData = {
                    exclusiveRates: this.data.exclusiveRates,
                    exclusiveDiscounts: this.data.exclusiveDiscounts
                };
                this.enabledSave = false;
                this.fillHasModified({
                    "data": "agency",
                    "value": this.enabledSave
                });
            },
        },
        watch: {
            'storeAgency.id': function (newVal, oldVal){
                if (newVal !== null && typeof newVal !== 'undefined') {
                    this.data = {
                        id: this.storeAgency.id,
                        name: this.storeAgency.name,
                        exclusiveRates: this.storeAgency.exclusiveRates,
                        exclusiveDiscounts: this.storeAgency.exclusiveDiscounts
                    };
                    this.initialData = {
                        exclusiveRates: this.storeAgency.exclusiveRates,
                        exclusiveDiscounts: this.storeAgency.exclusiveDiscounts
                    };
                }
            },
        },
    }

</script>